import type Phaser from "phaser";
import { TICK_MS } from "../../sim";
import { ANIMATIONS, type AnimationKey } from "../assets";

/** legacy: every AnimationSprite used a frame interval of 3 ticks (45 ms). */
const FRAME_INTERVAL_TICKS = 3;
const FRAME_RATE = 1000 / (FRAME_INTERVAL_TICKS * TICK_MS);

/** Registers the original frame animations once per game (idempotent). */
export function registerAnimations(scene: Phaser.Scene): void {
	for (const [key, frames] of Object.entries(ANIMATIONS) as [AnimationKey, readonly string[]][]) {
		if (scene.anims.exists(key)) continue;
		scene.anims.create({
			key,
			frames: frames.map((frame) => ({ key: frame })),
			frameRate: FRAME_RATE,
			repeat: 0,
		});
	}
}
